import React from "react";

import { Stack, useTheme } from "@bps/fluent-ui";
import { SectionTitle } from "@components/SectionTitle";
import { withPermissions } from "@components/withPermissions";
import { Permissions } from "@libs/permissions/permissions.enum";

import { BulkActionsForm } from "./BulkActionsForm";

const BulkActionsScreenBase: React.FC = () => {
  const theme = useTheme();
  return (
    <Stack verticalFill>
      <Stack
        verticalFill
        styles={{
          root: { padding: theme.spacing.s1 }
        }}
        tokens={{ childrenGap: theme.spacing.s1 }}
      >
        <SectionTitle>Bulk Actions</SectionTitle>

        <BulkActionsForm />
      </Stack>
    </Stack>
  );
};

export const BulkActionsScreen = withPermissions(
  BulkActionsScreenBase,
  [Permissions.PltFieldManagementRead, Permissions.PltFieldManagementWrite],
  "or"
);
